<div class="modal fade" id="addNewUser" tabindex="-1" aria-labelledby="addNewUserLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg user-modal-dialog">
    <div class="border-0 shadow modal-content rounded-4 user-modal">
      <form class="user-modal-form" [formGroup]="form" (ngSubmit)="onSave()">
        <div class="py-5 modal-header px-7">
          <h4 class="modal-title fw-bold text-dark" id="addNewUserLabel">ผู้ใช้งาน</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="clearForm()"></button>
        </div>

        <div class="py-6 px-7 modal-body">
          <div class="row g-5">
            <div class="col-12">
              <app-input formControlName="email" label="อีเมล" [required]="true" [isDisabled]="isEditMode"
                [errorMessage]="errors.email ?? ''" [error]="errors.email"></app-input>
            </div>

            <div class="col-md-6">
              <app-select formControlName="academicRankId" label="ตำแหน่งทางวิชาการ" [options]="academicRanks"
                bindLabel="name" bindValue="id" [searchable]="false"></app-select>
            </div>

            <div class="col-md-6">
              <app-input formControlName="fullName" label="ชื่อ - นามสกุล" [required]="true"
                [errorMessage]="errors.fullName ?? ''" [error]="errors.fullName"></app-input>
            </div>

            <div class="col-12">
              <app-select formControlName="positionId" label="ตำแหน่ง" [options]="positions" bindLabel="name"
                bindValue="id" [required]="true" [errorMessage]="errors.positionId ?? ''"
                [error]="errors.positionId"></app-select>
            </div>

            <div class="col-md-6">
              <app-select formControlName="departmentId" label="สาขาวิชา" [options]="departments" bindLabel="name"
                bindValue="id" [required]="true" [errorMessage]="errors.departmentId ?? ''"
                [error]="errors.departmentId"></app-select>
            </div>

            <div class="col-12">
              <div class="user-role-label required">
                บทบาทการใช้งาน
              </div>
              @if (errors.roleIds) {
              <span class="user-role-error">{{ errors.roleIds | translate }}</span>
              }
              @for (group of roleGroups; track group.title) {
              <section class="user-role-group">
                <h5>{{ group.title }}</h5>
                <div class="user-role-grid">
                  @for (role of group.roles; track role.id) {
                  <div class="user-role-option">
                    <app-checkbox [name]="'role-' + role.id" [inputLabel]="role.label" [labelMode]="LabelMode.NO_LABEL"
                      [value]="isRoleChecked(role.id)" [isDisabled]="isRoleDisabled(role.id)"
                      InputClass="user-role-checkbox" (inputChange)="onRoleChange(role.id, $event)"></app-checkbox>
                  </div>
                  }
                </div>
              </section>
              }
            </div>
          </div>
        </div>

        <div class="pt-2 pb-6 border-0 px-7 modal-footer">
          <button type="button" class="btn btn-secondary fw-bold me-3" data-bs-dismiss="modal" (click)="clearForm()">
            {{ "COMPONENT.CANCEL" | translate }}
          </button>
          <button type="submit" class="text-white btn fw-bold user-save-button" [disabled]="isSaving">
            {{ "COMPONENT.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-confirm-dialog
  #saveUserConfirmDialog
  modalId="saveUserConfirm"
  icon="warning"
  title="ยืนยันการบันทึกข้อมูล"
  message="คุณต้องการบันทึกข้อมูลนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isSaving"
  (confirmed)="onConfirmSave()"
></app-confirm-dialog>
